module.exports = __webpack_public_path__ + "img/box2_bg_dark.179d5ec2.png";